import { motion } from 'framer-motion';
import styles from './Hero.module.css';

const PHOTOS = [
  '/IMG_9854.JPG',
  '/bet-awards-party.webp',
  '/bdawson_community-1350665.webp',
  '/img-6427.webp',
  '/IMG_0109.JPG',
  '/img-8103.webp',
  '/bet-radio-djs.webp',
  '/img-9765.webp',
  '/img-8672.webp',
  '/img-9890.webp'
];

const TRACK = [...PHOTOS, ...PHOTOS, ...PHOTOS, ...PHOTOS];

export default function Hero() {
  return (
    <section className={styles.hero} id="hero">
      <div className={styles.marquee} aria-hidden="true">
        <div className={styles.track}>
          {TRACK.map((src, i) => (
            <img key={i} src={src} alt="" className={styles.photo} loading={i < 3 ? 'eager' : 'lazy'} />
          ))}
        </div>
      </div>
      <div className={styles.overlay} />
      <div className={styles.glow} aria-hidden="true" />
      <div className={styles.container}>
        <motion.h1
          className={styles.headline}
          initial={{ opacity: 0, y: 16 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7, ease: 'easeOut' }}
        >
          &ldquo;Make The World <span className={styles.gold}>Unite</span> Again&rdquo;
        </motion.h1>
        <motion.p
          className={styles.subheadline}
          initial={{ opacity: 0, y: 16 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7, ease: 'easeOut', delay: 0.15 }}
        >
          Bringing the world together one beat at a time.
        </motion.p>
      </div>
    </section>
  );
}
